import React, { useState, useRef } from 'react';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';

import api from './../../service/api';

export default function CreateExpenseCategory(props) {
    var emptyElement = {
        description: ''
    }

    const {
        visible,
        handleCancel,
        onCreate
    } = props;

    const [element, setElement] = useState({...emptyElement});
    const [submitted, setSubmitted] = useState(false);
    const [disabled, setDisabled] = useState(false);

    const toast = useRef(null);

    const onInputChange = (e, name) => {
        const val = e.value || (e.target && e.target.value) || '';
        let _element = { ...element };
        _element[`${name}`] = val;

        setElement(_element);
    }

    const onHide = () => {
        setElement({...emptyElement});
        if(typeof handleCancel === 'function') handleCancel();
    }

    return (
        <>
            <Toast ref={toast} />
            <Dialog visible={visible} style={{ width: '450px' }} header="Nova categoria" modal className="p-fluid" footer={() => {
                return(
                    <>
                        <Button label="Cancelar" disabled={disabled} icon="pi pi-times" className="p-button-text" onClick={onHide} />
                        <Button label="Salvar" onClick={() => {
                            if(!element.description) return setSubmitted(true);

                            setDisabled(true);
                            api().post('/expensecategory/create', {...element}).then(response => {
                                setDisabled(false);
                                if(response.status === 200 && response.data.result){
                                    toast.current.show({severity: 'success', summary: 'Sucesso', detail: response.data.message});
                                } else {
                                    toast.current.show({severity: 'warn', summary: 'Atenção', detail: response.data.message});
                                }
                                if(typeof onCreate === 'function')
                                    onCreate(response.data);
                            });

                        }} loading={disabled} icon="pi pi-check" className="p-button-text"  />
                    </>
                );
            }} onHide={onHide}>
                            
                <div className="field">
                    <label htmlFor="name">Descrição</label>
                    <InputText disabled={disabled} id="name" value={element.description} onChange={(e) => onInputChange(e, 'description')} required autoFocus />
                    {submitted && !element.description && <small className="p-invalid p-error">Este campo é obrigatório.</small>}
                </div>
            </Dialog>
        </>
    );
}